var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","disabled":!_vm.show || _vm.VerifyCode == '',"loading":_vm.loading},on:{"click":_vm.getCode}},[_vm._v(" "+_vm._s(_vm.show ? _vm.$t('public.btn11') : _vm.count)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }